import TagTemplatesManager from '~/admin/tag_templates_manager'
import ReactController from '~/controllers/react_controller'

export default class TagTemplatesController extends ReactController {
  static values = {
    name: String,
    tags: Array,
    groups: Array,
    group: String,
    url: String,
    method: String,
  }

  createComponent() {
    return (
      <TagTemplatesManager
        groups={this.groupsValue}
        name={this.nameValue}
        tags={this.tagsValue}
        group={this.groupValue}
        url={this.urlValue}
        method={this.methodValue}
      />
    )
  }
}
